export default "__VITE_ASSET__BzzYJobv__"